import { useMemo } from "react";
import { StorageService } from "../services/StorageService";
import { Constants } from "../Constants";

export const useInitialFeedbackBannerState = () => {
  return useMemo(() => {
    const storageService = new StorageService();
    const stored = storageService.get(Constants.storage.keys.feedbackBanner);
    return stored !== null ? JSON.parse(stored.toString()) : true;
  }, []);
};
